import { Renderer2, ElementRef } from '@angular/core';
import { InjectionToken } from '@angular/core';

export const APP_CONFIG = new InjectionToken<Object>('APP CONFIG FILE');
export class appConfig {
    private static _appConfigService;

    public static get appConfigService() {
        return this._appConfigService;
    }
    public static set appConfigService(value) {
        this._appConfigService = value;
    }

    public static updateConstant(configData) {
        Constants.BASE_API_URL = configData.baseApiUrl;
        Constants.GATEWAY_BASE_API_URL = configData.gatewayBaseApiUrl;
        Constants.ADMIN_BASE_API_URL = configData.adminBaseApiUrl;
        Constants.APP_BASE_API_URL = configData.appBaseApiUrl;
        Constants.Email_APP_BASE_API_URL = configData.emailAppBaseApiUrl;
        Constants.INACTIVITY_TIMEOUT_IN_MINS = configData.inactivityTimeoutInMins;
        Constants.KSA_ADMIN_BASE_API_URL = configData.ksaAdminBaseApiUrl;
        Constants.deploymentWindowCheckTimeInSeconds = configData?.deploymentWindowCheckTimeInSeconds || 10000;
    }
}

export class Constants {
    public static deploymentWindowCheckTimeInSeconds = 10000;
    public static BASE_API_URL = '';
    public static GATEWAY_BASE_API_URL = '';
    public static INACTIVITY_TIMEOUT_IN_MINS = 15;
    public static readonly LOCALE = 'en-IN';
    public static readonly AUTO_LOGOUT_URL =
        'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=' + window.location.origin;
    public static ADMIN_BASE_API_URL = '';
    public static APP_BASE_API_URL = '';
    public static Email_APP_BASE_API_URL = '';
    public static KSA_ADMIN_BASE_API_URL = '';

    public static readonly FILE_SUCCESS_MSG = 'File uploaded successfully.';
    public static readonly FILE_DUPLICATE_MSG = 'Duplicate files not allowed';
    public static readonly FILE_EXCEPTION_MSG = 'Exception';
    public static readonly FILE_NORECORD_MSG = 'No records';
    public static readonly DATE_PATTERN = "yyyy-MM-dd HH:mm:ss";
    public static readonly DELETE_CONFIRMATION_POPUP = "Do you want to delete Registrtaion Id  ";
    public static readonly TOTAL_SELECTION_ALLWOED = 1;
    public static readonly TOTAL_ADDITION_ALLWOED = 1;
    public static readonly MAX_SELECTION_ALLOWED = "Maximum " + Constants.TOTAL_SELECTION_ALLWOED + " record can be selected";
    public static readonly MAX_ADDITION_ALLOWED = "Maximum " + Constants.TOTAL_ADDITION_ALLWOED + " record can be added";
    public static readonly SAVE_RECORD_FIRST = "Save new record first";
    public static readonly CANNOT_HAVE_MULTIPLE_MAPPING = " cannot be mapped to multiple registrations";
    public static readonly MAX_LENGTH_ENTITY = "Entity Name max 100 characters allowed";
    public static readonly MAX_LENGTH_REGISTRATION = "Registration Id max 14 alphanumeric allowed"
    public static readonly EDIT_POP_UP = "Name of the entity should be updated in all entries or only this specific entry?";
    public static readonly GBLShortName = "GBL";
    public static readonly GlobalCountryName = 'Global';
    public static readonly InwardScreenCode = 'SCREEN0005';
    public static readonly TaxIDScreenCode = 'SCREEN0007';
    public static readonly InwardInvoicesTabScreenName = 'Inward Invoices - Invoice';
    public static readonly ReportScreenCode = 'SCREEN0006';
    public static readonly OutwardScreenCode = 'SCREEN0003';
    public static readonly InwardDownloadButtonCode = 'BUDO050020';
    public static readonly OutwardDownloadButtonCode = 'ACTN000001';
    public static readonly CONFIGURE_ACCESS = 'CONFIGURE ACCESS';
    public static readonly NO_ACCESS = 'No ACCESS';
    public static readonly GTES_CONSOLIDATED_INVOICE = "GTES CONSOLIDATED INVOICE";
    public static readonly INDIVIDUAL_E_INVOICE = "INDIVIDUAL E-INVOICE";
    public static readonly POWER_BI_REPORTS_ENDPOINT = "/getBIReportAccess";
    public static readonly INACTIVE = "INACTIVE";
    public static readonly ACTIVE = "ACTIVE";

}

export class utility {
    handleKeyPress(event: KeyboardEvent): void {
        if (event.key === 'Enter' || event.key === ' ') {
            const activeItem = document.activeElement as HTMLElement;
            activeItem.click();
            event.preventDefault();
        }
    }
    setFilterIconAttributes(renderer: Renderer2, elementRef: ElementRef): void {
        const filtericonElements = elementRef.nativeElement.querySelectorAll('.pi.pi-filter-icon.pi-filter');
        filtericonElements.forEach(iconElement => {
            renderer.setProperty(iconElement, 'role', 'img');
            renderer.setAttribute(iconElement, 'aria-label', 'Filter');
        });
    }

    setRoleAttributes(renderer: Renderer2, elementRef: ElementRef, rolevalue: String) {
        const elements = elementRef.nativeElement.querySelectorAll('#custom-MenuBar li.p-menuitem a.p-menuitem-link');
        elements.forEach(element => {
            renderer.setProperty(element, 'role', rolevalue);
            // renderer.setStyle(element, 'background', 'blue');
        });
    }

    setPaginatorAttributes(renderer: Renderer2, elementRef: ElementRef) {
        const firstPageIcon = elementRef.nativeElement.querySelector('button.p-paginator-first.p-paginator-element.p-link');
        const prevPageIcon = elementRef.nativeElement.querySelector('button.p-paginator-prev.p-paginator-element.p-link');
        const nextPageIcon = elementRef.nativeElement.querySelector('button.p-paginator-next.p-paginator-element.p-link');
        const lastPageIcon = elementRef.nativeElement.querySelector('button.p-paginator-last.p-paginator-element.p-link');
        const dropdownElement = elementRef.nativeElement.querySelector('p-paginator div.p-paginator-bottom p-dropdown div.p-paginator-rpp-options');
        // const dropDownSelectedValue = dropdownElement.querySelector('.p-dropdown-label').textContent.trim();
        renderer.setAttribute(firstPageIcon, 'aria-label', 'First Page');
        renderer.setAttribute(prevPageIcon, 'aria-label', 'Previous Page');
        renderer.setAttribute(nextPageIcon, 'aria-label', 'Next Page');
        renderer.setAttribute(lastPageIcon, 'aria-label', 'Last Page');
        // renderer.setAttribute(dropdownElement, 'aria-label', `${dropDownSelectedValue} rows per page Combobox Selected`);
    }
}